import React from 'react';
import Button from '../Button/Button';
import './apply-now.scss';

const ApplyNow = () => {
  return (
    <div className='apply-now'>
      <div className='apply-now__container'>
        <span className='apply-now__holding'>
          Check back in June 2022 for information about the next round of Fresh Fund applications
        </span>
      </div>
    </div>
  );
};

export default ApplyNow;
